import { useSelector } from "react-redux";
import { StateExtended } from "../../_config/interfaces/stateExtended";

export const useAuthStatus = () => useSelector((state: StateExtended) => state.user.isAuthenticated);
export const useUserSelector = () => useSelector((state: StateExtended) => state.user.user);
export const useIsForgotPassword = () => useSelector((state: StateExtended) => state.user.user?.isForgotPassword === true);
export const useUserListSelector = () => useSelector((state: StateExtended) => state.userManagement.users);
export const useMenusSelector = () => useSelector((state: StateExtended) => state.user.menus);
export const useMenuPermissionsSelector = () => useSelector((state: StateExtended) => state.user.menuPermissions);
